module.exports = __webpack_public_path__ + "static/media/fruits_20.fd6b1dde.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_20.csv
// module id = 685
// module chunks = 0